module.exports = __webpack_public_path__ + "be92a4d70bbd385d16dc6101a30813b5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-22.png
// module id = 2185
// module chunks = 0